var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enhance-tag"},[_vm._l((_vm.shorexTags),function(item){return [(item.imageUe)?_c('img',{key:item.id,staticClass:"enhance-tag-item",style:({marginBottom: _vm.marginBottom+'px'}),attrs:{"src":item.imageUe,"alt":""}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }